import {mapState, mapGetters} from 'vuex'

export default {
  computed: {
    ...mapState({
      themeObj: state => state.theme
    }),
    ...mapGetters(['getThemeByName']),
    themeVars: function () {
      let currentTheme = this.getThemeByName(this.themeObj.current)
      if (currentTheme) {
        return {
          '--theme-color': currentTheme.themeColor,
          '--theme-light-color': `${currentTheme.themeColor}1A`
        }
      }
    }
  }
}
